import Utils from '@/common/utils/utils';
import React from 'react';
import trI18n from '@/common/utils/trI18n';
import { useTranslationSubscription } from '@/hooks/useTranslation';

export default function CorporationOptionUsage({ optionUsages }) {
    // Re-render when the translation dictionary loads/updates.
    useTranslationSubscription();

    if (Utils.isEmptyArray(optionUsages)) return null;

    return (
        <>
            {optionUsages?.map((option, index) => {
                return (
                    <div className="item-option-usage" key={index}>
                        <div className="title">{trI18n(option.label)}</div>
                        <div className="option">{option.value} {option.unit}</div>
                    </div>
                );
            })}
        </>
    );
}
